import { Component, OnInit,ViewChild,TemplateRef,ElementRef, group,HostListener } from '@angular/core';
import {NgbModal, ModalDismissReasons,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { GroupService } from '../../service/group.service';
import { HttpErrorResponse } from '@angular/common/http';
import {Globals} from '../.././globals';
import { commonService } from '../../service/common.service';
import {FileSelectDirective,FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
declare var CKEDITOR:any;

@Component({
  selector: 'app-groupdetails',
  templateUrl: './groupdetails.component.html',
  styleUrls: ['./groupdetails.component.css'],
  providers:[GroupService]
})
export class GroupdetailsComponent implements OnInit {
modalReference:NgbModalRef;
groupId:any;
groupDetails:any;
user:any;
groupmemberdetails:any=[];
readonly path  =  this.global.groupProfileUrl;
readonly profileUrl = this.global.profileUrl;
profileurl=this.global.profileUrl;
actions: string[] = ['User', 'Batch'];
action = 'User';
searchtxt:any;
userlist:any=[];
groupbatchdetails:any;
viewmore=false;
actionBox:any;
search:any;
msg:any;
isError=false;
isSuccess=false;
groupmember:any;
newconversationbox=false;
content:any;
feedData:any=[];
feedviewmore=false;
onlineUser:any=[];
commentEditbox:any;
commentbox:any;
replybox:any;
orderNumber:any;
ckeConfig:any;
contentbox:any;
modalReferenceImg:any;
ckeditorevent:any;
msgpopup:any;
attachmentUrl =this.global.siteUrl+'file/upload?folder='+this.global.postAttachmentFolder+'&mediaFor=userPost';
ImageattachmentUrl =this.global.siteUrl+'file/upload?folder=ckeditor&mediaFor=ckeditor';  
imageuploaders:FileUploader=new FileUploader({url:this.ImageattachmentUrl,authToken:localStorage.getItem('_to')});;
//@ViewChild('group') public creategroup: TemplateRef<any>;
//@ViewChild('postbox') public postbox:ElementRef;
//@ViewChild('actionbutton') public actionbutton:ElementRef;
//@ViewChild('postcontentbox') public postcontentbox:ElementRef;
//@ViewChild('invitemember') public invitemember:ElementRef;

progress:any;


constructor(private _common:commonService,private global:Globals,private _group:GroupService,private modalService: NgbModal,private router:Router,private route:ActivatedRoute) { 

  this.commentEditbox={};
  this.commentbox={};
  this.replybox={};
  this.contentbox={};
  this.imageuploaders.onErrorItem = (item, response, status, headers) => this.onErrorItemImage(item, response, status, headers);
  this.imageuploaders.onSuccessItem = (item, response, status, headers) => this.onSuccessItemImage(item, response, status, headers);
}



ngOnInit() {
  this.route.params.subscribe(params => {
   //  this.groupId = atob(decodeURIComponent(params.id)); 
     this.groupId = params.id; 
})

// get user details
this._common.profile.subscribe((data:any)=>{
          this.user = data;
})

// getOnlineUser
this._common.getOnlineUser.subscribe((data:any)=>{
this.onlineUser = data;
})


this.getGroupDetails();
//this.getgroupmemberdetails();


this.ckeConfig = {
  height: 100,
  language: "en",
  image_previewText:'',
  allowedContent: true,
  extraPlugins: 'uploadimage',
  
  mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=TeX-AMS_HTML',
 // allowedContent: true,
 // extraPlugins: "divarea",
  toolbar: [
     // { name: "editing", items: ["Scayt", "Find", "Replace", "SelectAll"] },
     // { name: "clipboard", items: ["Cut", "Copy", "Paste", "PasteText", "PasteFromWord", "-", "Undo", "Redo"] },
      { name: "links", items: ["Link", "Unlink", "Anchor"] },
    //  { name: "tools", items: ["Maximize", "ShowBlocks", "Preview", "Print", "Templates"] },
     // { name: "document", items: ["Source"] },
      { name: "insert", items: ["Image","customImageupload","Table", "HorizontalRule", "SpecialChar", "Iframe", "imageExplorer"] },
     //{ name: "insert", items: ["Image", "Table",  "imageExplorer","Iframe"] },
    // For New Line  "/",
      { name: "basicstyles", items: ["Bold", "Italic", "Underline", "Strike", "Subscript", "Superscript", "-", "RemoveFormat"] },
      { name: "paragraph", items: ["NumberedList", "BulletedList", "-", "Outdent", "Indent", "Blockquote"] },
     // { name: "justify", items: ["JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"] },
    //  { name: "styles", items: ["Styles", "Format", "FontSize", "-", "TextColor", "BGColor"] }
  ],
  filebrowserUploadUrl : this.global.objectStorage+'ckeditor/upload'
};



}


getGroupDetails(){
      this._group.getGroupDetails({"group":this.groupId}).subscribe((data:any)=>{
        if(data.error==0){ 
         this.groupDetails=data.results; 
         this.groupfeed();
/*
         if(data.results.groupUsers.length>0 && data.results.groupUsers[0].status=="request"){
             this.actionbutton.nativeElement.innerHTML="Cancel Request";
             this.postbox.nativeElement.remove();
             this.postcontentbox.nativeElement.remove();
             this.invitemember.nativeElement.remove();
             
         }else if(data.results.groupUsers.length>0 && data.results.groupUsers[0].status=="cancel"){
             this.actionbutton.nativeElement.innerHTML="Request to join";
             this.postbox.nativeElement.remove();
             this.postcontentbox.nativeElement.remove();
             this.invitemember.nativeElement.remove();
        }else if(data.results.groupUsers.length>0 && data.results.groupUsers[0].status=="confirmed"){
              this.actionbutton.nativeElement.remove();
              this.groupfeed();
        }else if(data.results.createdBy==this.user.id){
              this.actionbutton.nativeElement.remove();
              this.groupfeed();
        }else{
             this.postbox.nativeElement.remove();
             this.postcontentbox.nativeElement.remove();
             this.invitemember.nativeElement.remove();
        }
      }else{
          if(data.message=="Failed to authenticate token."){
            this.router.navigate(['/']);
          }else{
          //this.msg = data.message;
         // this.isError = true;
         // this.isSuccess = false;
          }*/
        }
        
    },
        (error : HttpErrorResponse)=>{
        //  this.isError = true;
          //this.msg="internal server error!";
        });

      
    
}

getgroupmemberdetails(){

  this._group.getgroupmemberdetails({"group":this.groupId}).subscribe((data:any)=>{
    if(data.error==0){ 
      this.groupmember = data.results;
  }else{
      if(data.message=="Failed to authenticate token."){
        this.router.navigate(['/']);
      }else{
      //this.msg = data.message;
     // this.isError = true;
     // this.isSuccess = false;
      }
    }
},
    (error : HttpErrorResponse)=>{
    //  this.isError = true;
      //this.msg="internal server error!";
    });

}
requesttojoin(){
  /*
 if(this.actionbutton.nativeElement.innerHTML=="Request to join"){  
    var stauts =  'REQUEST_JOIN';
 }else if(this.actionbutton.nativeElement.innerHTML=="Cancel Request"){
    var stauts =  'REQUEST_CANCEL';
 }else{
    alert('Somthing went wrong.Please try to latter.');
    return false;

 }

this._group.requestoJoin({"group":this.groupId,"status":stauts}).subscribe((data:any)=>{
    if(data.error==0){ 
        if(this.actionbutton.nativeElement.innerHTML=="Request to join"){  
            this.actionbutton.nativeElement.innerHTML="Cancel Request";
        }else{
          this.actionbutton.nativeElement.innerHTML="Request to join";
        }
    }else{
      if(data.message=="Failed to authenticate token."){
        this.router.navigate(['/']);
      }else{
      //this.msg = data.message;
     // this.isError = true;
     // this.isSuccess = false;
      }
    }
},
    (error : HttpErrorResponse)=>{
    //  this.isError = true;
      //this.msg="internal server error!";
    });
*/
}
openGroupForm(content){
  


  if(content != null){
    this.modalReference =  this.modalService.open(content,{size: 'lg',backdrop : 'static',
    keyboard : false }); 
  }
  this.actionBox="User";
  this.getUser();
}


filteruser(search,actiontxt){
 
 /* console.log(actiontxt);
 
 */
var searchtxt  = search.trim();
if(searchtxt!=""){ 
      this._group.filteruser({"search":searchtxt,"action":actiontxt,"group":this.groupId}).subscribe((data:any)=>{
      if(data.error==0){ 
  
        if(actiontxt=="User"){
          this.groupmemberdetails = data.results.rows;
        }else{
          this.groupbatchdetails = data.results.rows;
        }

      }else{
        if(data.message=="Failed to authenticate token."){
          this.router.navigate(['/']);
        }else{
        }
        }
    },
        (error : HttpErrorResponse)=>{
        //  this.isError = true;
          //this.msg="internal server error!";
        });
}else{
  this.groupmemberdetails=[];
}
}


putdata(objData,event,action){

    this.searchtxt =event.target.innerHTML; 
    this.groupmemberdetails=[];
    this.userlist=[];
    this.groupbatchdetails=[];

    this.actionBox = action;
    this.search =  objData;
   

    if(this.actionBox=="User"){
       this.viewmore=false;
       this.userlist.push(this.search);
    }else{
      this._group.batchuser({"batch":this.search.id,"group":this.groupId}).subscribe((data:any)=>{
      if(data.error==0){ 
        this.userlist= data.results.rows;
       
        if(data.results.count>this.userlist.length){
          this.viewmore=true;
       }else{
        this.viewmore=false;
       }
      }else{
        if(data.message=="Failed to authenticate token."){
          this.router.navigate(['/']);
        }else{
        }
      }
  },
      (error : HttpErrorResponse)=>{
      });



    }

}

usertype(event){
     this.isError = false;
     this.searchtxt="";
      this.userlist=[];
      this.search="";
      this.actionBox = event.target.options[event.target.selectedIndex].text;
      this.getUser();
}


getUser(){
     this.isError = false;
     this.groupmemberdetails=[];
      this.groupbatchdetails=[];

      
  if(this.actionBox=="User"){

    this._group.filteruser({"search":'',"group":this.groupId,"action":this.actionBox,"offset":this.userlist.length?this.userlist.length:0}).subscribe((data:any)=>{
      if(data.error==0){ 
        Array.prototype.push.apply(this.userlist,data.results.rows);
               if(data.results.count>this.userlist.length){
                  this.viewmore=true;
               }else{
                this.viewmore=false;
               }

      }else{
        if(data.message=="Failed to authenticate token."){
          this.router.navigate(['/']);
        }else{
        }
        }
    },
        (error : HttpErrorResponse)=>{
        });       
  }else{

  var batch = ""
  if(this.search){
      batch = this.search.id;
  }

    this._group.batchuser({"batch":batch,"offset":this.userlist.length?this.userlist.length:0,"group":this.groupId}).subscribe((data:any)=>{
      if(data.error==0){ 
        Array.prototype.push.apply(this.userlist,data.results.rows);
        if(data.results.count>this.userlist.length){
          this.viewmore=true;
       }else{
        this.viewmore=false;
       }
      }else{
        if(data.message=="Failed to authenticate token."){
          this.router.navigate(['/']);
        }else{
        //this.msg = data.message;
       // this.isError = true;
       // this.isSuccess = false;
        }
      }
  },
      (error : HttpErrorResponse)=>{
      //  this.isError = true;
        //this.msg="internal server error!";
      });

  }
}




invitation(formObj){
var pObj = [];
$('input:checkbox:checked').each(function () {
  var sThisVal = $(this).val();
  if(sThisVal!="on"){
    pObj.push(sThisVal);
  }
});


if(!this.isEmpty(pObj)){

this._group.addinvitation({"group":this.groupId,"requestData":pObj}).subscribe((data:any)=>{
  if(data.error==0){ 
    this.userlist=[];
    this.modalReference.close();
   // this.groupmemberdetails = data.results;
}else{
    if(data.message=="Failed to authenticate token."){
      this.router.navigate(['/']);
    }else{
    this.msg = data.message;
    this.isError = true;
    this.isSuccess = false;
    }
  }
},
  (error : HttpErrorResponse)=>{
    this.isError = true;
    this.msg="internal server error!";
  });

}else{
 this.msg = "No user are selected. please select at least one user";
 this.isError = true;
} 

}
isEmpty(obj) {
for(var prop in obj) {
    if(obj.hasOwnProperty(prop))
        return false;
}
return true;

}

viewmoreuser(){
 this.getUser()

}


newconversation(){
this.newconversationbox=true;

}

newconversationpost(formData){

if(formData.status=="INVALID"){
  

 }else{
  //console.log(formData.value);
  var objPost = {};
  if(formData.value.isfuture==true && formData.value.launchDate!= undefined && formData.value.launchtime!= undefined && Object.keys(formData.value.launchDate).length > 0){
    formData.value['launchDate']= this.datetimeMerge(formData.value.launchDate,formData.value.launchtime);
    objPost['publishDate']    = formData.value['launchDate'];
  } 
  formData.value['group']= this.groupId;
  this._group.addNewPostGroup(formData.value).subscribe((data : any)=>{
  if(data.error==0){ 
    this.content="";
    this.newconversationbox=false;
     var postId = data.postId;
    
     objPost['id']=postId;
     objPost['groupId']=this.groupId;
     objPost['postContent']=formData.value.content;
     objPost['createdAt']= new Date();      
     objPost['user'] ={'firstName':this.user.firstName,'lastName':this.user.lastName,'photo':this.user.photo,'email':this.user.email};
     
     this.feedData.unshift(objPost);
  }else{
    if(data.message=="Failed to authenticate token."){
      this.router.navigate(['/']);
    }else{
    this.msg = data.message;
    this.isError = true;
    this.isSuccess = false;
    }
  }
},
  (error : HttpErrorResponse)=>{
    this.isError = true;
    this.msg="internal server error!";
  });

} 
}

datetimeMerge(date,time){
  let string="";
  let month = (date.month<10)?'0'+date.month:date.month ;
  let day = (date.day<10)?'0'+date.day:date.day ;
  
  let hour=(time.hour<10)?'0'+time.hour:time.hour ;
  let minute=(time.minute<10)?'0'+time.minute:time.minute ;

  string=date.year+'-'+month+'-'+day+' '+hour+':'+minute+':00';
  
  return string;

}
groupfeed(){

this._group.groupfeed({"type":'ad',"group":this.groupId,'limit':10,'offset':this.feedData.length?this.feedData.length:0}).subscribe((data:any)=>{
  if(data.error==0){ 
   Array.prototype.push.apply(this.feedData,data.results.rows);
    if(data.results.count>this.feedData.length){
    this.feedviewmore=true;
    }else{
    this.feedviewmore=false;
    }
}else{
    if(data.message=="Failed to authenticate token."){
      this.router.navigate(['/']);
    }else{
    this.msg = data.message;
    this.isError = true;
    this.isSuccess = false;
    }
  }
},
  (error : HttpErrorResponse)=>{
   this.isError = true;
   this.msg="internal server error!";
  });

}


datediff(date){
let date_future:any;
let date_now:any;

 date_future = new Date();
 date_now = new Date(date);
 let seconds = Math.floor((date_future - (date_now))/1000);
 let minutes = Math.floor(seconds/60);
 let hours = Math.floor(minutes/60);
 let days = Math.floor(hours/24);
 
   hours = hours-(days*24);
   minutes = minutes-(days*24*60)-(hours*60);
   seconds = seconds-(days*24*60*60)-(hours*60*60)-(minutes*60);
   let res="";
   if(days>30){
     res=date;
   }else if(days){
     res=days+"d ago";
   }else if(hours){

     res=hours+"h ";
     if(minutes){
       res +=minutes+"m ";
     }            
     res +="ago";
   }else if(minutes){
     res =minutes+"m ago";

   }else{
     res ="now";
   }
   return res;

}



   /*=============================== Like =================*/
   postLike(feed,react){ 
    if(Object.keys(this.user).length == 0){ 
     // this.needLogin();
      return false;
    }      
    var obj={};
    obj['userId']=this.user.id;
    obj['postId']=feed.id;
    obj['react']=react;            
        this._group.savePostLike(obj).subscribe((data:any)=>{
          if(!feed.groupLikeCount){
            feed.groupLikeCount=0;
          }
          if(!feed.groupunLikeCount){
            feed.groupunLikeCount=0;
          }
          if(react==0){                
            if(feed.mylikeAction=='Like'){
              feed.mylike=0;
              feed.groupLikeCount -=1;
              feed.groupunLikeCount +=1;
            }else if(!feed.mylikeAction){
              feed.groupunLikeCount +=1;
            }
            feed.mylikeAction='Unlike';

          }else{
            if(feed.mylikeAction=='Unlike'){
              feed.mylike=1;
              feed.groupLikeCount +=1;
              feed.groupunLikeCount -=1;
            }else if(!feed.mylikeAction){
              feed.groupLikeCount +=1;
            }
            feed.mylikeAction='Like';

          }
                       
        },(error : HttpErrorResponse)=>{              
            this.msg="internal server error!";
        })   
    

  }

  showPostcomment(feed){
     if(feed.showAnscomment==true){
      feed.showAnscomment=false;          
       return false;
     }
    if(!feed.commentList || feed.commentList.length==0){        
     this.loadComment(feed,'Comment','');
    
    }
    feed.showAnscomment=true;  
   

   }

   loadComment(feed,forcall,divobject){
    
    if(!feed.commentList){
      feed.commentList=[];
    }

    if(feed.commentCount > feed.commentList.length ){
      feed.isCommentLoad=true;
          var obj={};
          if(this.user)
          obj['userId']=this.user.id;
          obj['limit']=5;
          obj['offset']=feed.commentList.length;
          if(forcall=='Comment'){
            obj['postId']=feed.id;
          }else if(forcall=='reply'){
            obj['postId']=feed.postId;
            obj['pcomment']=feed.id;
          }

          obj['ordertype']='DESC';
          obj['orderby']='id';
          
            this._group.getComments(obj).subscribe((data:any)=>{
            
              if(data.error==0){
                if(data.result){
                  for(let i in data.result){
                    this.commentEditbox[data.result[i].id]=data.result[i].comment;
                  }
                }
                Array.prototype.push.apply(feed.commentList,data.result); 
                //console.log(feed.commentList);
              }
              feed.isCommentLoad=false;



            },(error : HttpErrorResponse)=>{ 
              feed.isCommentLoad=false;     
              this.msg="internal server error!";
            })


    }
  }

  getImagePath(path,anonymously){
    if(!path || anonymously==1){
      path='avatar.png';
    }
  let res=this.global.profileUrl+path;
  return res;

  }

  showCommentBox(feed){
    if(Object.keys(this.user).length == 0){ 
     // this.needLogin();
      return false;
    } 
    feed.showAttachment=false;
    if(feed.showCommentBox){
      feed.showCommentBox=false;
    }else{
      feed.showCommentBox=true;
      
     /* if(postObj.commentCount > postObj.commentCount && postObj.commentCount < 5){
        postObj.isCommentLoad=true;
        var obj={};
        obj['userId']=this.userData.id;
        obj['ansId']=postObj.id;
        obj['limit']=5;
        obj['offset']=postObj.commentList.length;
      
        this.forumsService.getComments(obj).subscribe((data:any)=>{
         
          if(data.error==0){
            if(data.result){
              for(let i in data.result){  
                this.commentEditbox[data.result[i].id]=data.result[i].comment;
              }
            }
            
            Array.prototype.push.apply(postObj.commentList,data.result); 
            //postObj.postComments.concat(data.result);
           // console.log(postObj.postComments);
          }
          postObj.isCommentLoad=false;



        },(error : HttpErrorResponse)=>{ 
          postObj.isCommentLoad=false;     
          this.msg="internal server error!";
        })


      }
      */
    }
  }


  saveComment(feed,commentValue){

    let objthis=this;
    if(commentValue){
          let commentObj={}
          commentObj['comment']=commentValue;
          commentObj['postId']=feed.id;
          commentObj['userId']=this.user.id;
          
         
          this._group.saveComment(commentObj).subscribe((data:any)=>{
            
            if(data.error==0){
              let commentData=data.result;                 
              commentData.user={firstName:this.user.firstName,lastName:this.user.lastName,photo:this.user.photo};
              commentData.likeCount=0;
              
             // commentData.commentAttachments=this.currentCommentMediaIds;
              if(!feed.commentList){
                feed.commentList=[];
              }
              //if(postObj.postComments.length<5){
                feed.commentList.unshift(commentData);
               // console.log(feed.commentList);
              //}
            
              feed.commentCount +=1;
           

            //  feed.commentMedia=[];
              this.commentbox[feed.id]="";
              feed.showAnscomment=false;
              this.showPostcomment(feed);
            }
            


          },(error : HttpErrorResponse)=>{  
              
              this.msg="internal server error!";
          })

    }        
  
  }


  commentLike(commentData){
    if(Object.keys(this.user).length == 0){ 
     // this.needLogin();  
      //return;
    }
    var obj={};
    obj['userId']=this.user.id;
    obj['commentId']=commentData.id;
    obj['react']=1;  

      if(commentData.mylike){            
        this._group.deleteCommentLike(obj).subscribe((data:any)=>{
          if(data.error==0){
          commentData.mylike=0;
          commentData.likeCount -=1;
          }
        },(error : HttpErrorResponse)=>{              
            this.msg="internal server error!";
        })              

      }else{            

        this._group.saveCommentLike(obj).subscribe((data:any)=>{
          if(data.error==0){
          commentData.mylike=1;
          commentData.likeCount +=1;
          }
        },(error : HttpErrorResponse)=>{              
            this.msg="internal server error!";
        })            
      }

  }

  replyTextboxShow(commentdata){
        
    if(commentdata.isShow){
      commentdata.isShow=false;

    }else{

      commentdata.isShow=true;
      
      if(!commentdata.commentList){
         commentdata.commentList=[];
      }
      if(commentdata.commentCount > commentdata.commentList.length && commentdata.commentList.length < 5){
       
        commentdata.isCommentLoad=true;
      var obj={};
       obj['userId']=this.user.id;
       obj['postId']=commentdata.postId;
       obj['pcomment']=commentdata.id;
       obj['limit']=5;
       obj['offset']=commentdata.commentList.length;
       obj['ordertype']='DESC';
       obj['orderby']='id';
      
        this._group.getComments(obj).subscribe((data:any)=>{
         
          if(data.error==0){
            if(data.result){
              for(let i in data.result){

                this.commentEditbox[data.result[i].id]=data.result[i].comment;
              }
            }
            Array.prototype.push.apply(commentdata.commentList,data.result); 
            //postObj.postComments.concat(data.result);
           // console.log(commentdata.commentList);
          }
          commentdata.isCommentLoad=false;



        },(error : HttpErrorResponse)=>{ 
          commentdata.isCommentLoad=false;     
          this.msg="internal server error!";
        })


      }




    }

  }

  enableEditor(Obj){
    if(Object.keys(this.user).length == 0){ 
     // this.needLogin();
      return false;
    } 
    Obj.isEditor=true;

  }

    /*===================================== Comment ==============================*/
    savereply(commentobj,commentValue){
        
      let objthis=this;
      if(commentValue){
            let commentInsertObj={}
            commentInsertObj['comment']=commentValue;
            commentInsertObj['postId']=commentobj.postId;
            commentInsertObj['userId']=this.user.id;
            commentInsertObj['pcomment']=commentobj.id;
            //commentInsertObj['mediaids']=[];
           

            this._group.saveComment(commentInsertObj).subscribe((data:any)=>{
              
              if(data.error==0){
                let commentData=data.result;
               
                commentData.user={firstName:this.user.firstName,lastName:this.user.lastName,photo:this.user.photo};
                commentData.likeCount=0;
                if(!commentobj.commentList){
                  commentobj.commentList=[];
                }
                //commentData.commentAttachments=this.currentCommentMediaIds;
               
               // if(commentobj.commentList.length<5){
                  commentobj.commentList.unshift(commentData);
               // }
                commentobj.commentCount +=1;
                objthis.replybox[commentobj.id]="";
                commentobj.commentMedia=[];
              }
            //  this.currentCommentMediaIds=[];


            },(error : HttpErrorResponse)=>{  
              
                this.msg="internal server error!";
            })

      }       

    }

    toggleoption(postObj){     
        
       
      if(postObj.showOption){
        postObj.showOption=false;
      }else{
        postObj.showOption=true;
      }
    }

    openEditComment(commentObj){     
      commentObj.editMode=true; 
      commentObj.showOption=false;          
    }

    cancelEditComment(commentObj){
      commentObj.editMode=false;
    }

    EditComment(commentObj){
        let obj = {};
        obj['id']=commentObj.id;
        obj['comment']=this.commentEditbox[commentObj.id];
          this._group.editComment(obj).subscribe((data:any)=>{
            commentObj.editMode=false;
            commentObj.comment=this.commentEditbox[commentObj.id];
          })

    }
    deleteComment(commentObj,parentObj,index){
      var obj={};
      obj['id']=commentObj.id;
      this._group.deleteComment(obj).subscribe((data:any)=>{
        if(data.error==0){
          try{
            parentObj.commentList.splice(index, 1);
          //  if(parentObj.postComments){
            // parentObj.postComments.splice(index,1);       // For Comment
           // }else{
              parentObj.commentCount -=1; // for reply && comment
    
       //     }   
        
          }catch(e){
            //console.log(e);
            this.msg="internal server error!";
          }            
        }
      },(error:HttpErrorResponse)=>{
        this.msg="internal server error!";
      })
    
    }

    ShortOrder(feed){
      this.orderNumber='';
     if(feed.shortOrderBox){
      feed.shortOrderBox=false;
    }else{
      feed.shortOrderBox=true;
    }

    }

    ordernumbersave(feed,order){
     
    let InsertObj={}
    InsertObj['postId']=feed.id;
    InsertObj['userId']=this.user.id;
    InsertObj['shortOrder']   = (order==0 || order=="")?'x':order;
    this._group.saveshortOrder(InsertObj).subscribe((data:any)=>{
      if(data.error==0){
          feed.shortOrder=order;
          feed.shortOrderBox=false;
        }else{
          this.msg="internal server error!";
        }},(error : HttpErrorResponse)=>{  
      
        this.msg="internal server error!";
    })


    }

    editcontent(feed, i) {
      feed.editContent = true;
      this.contentbox[feed.id] = feed.postContent;
    }
  
    editconversationpost(formData, feed) {
      if (formData.status == "INVALID") {
      } else {
        feed.postContent = formData.value.content;
        this._group.editPostGroup(feed).subscribe(
          (data: any) => {
            if (data.error == 0) {
              feed.editContent = false;
            } else {
              if (data.message == "Failed to authenticate token.") {
                this.router.navigate(["/"]);
              } else {
                this.msg = data.message;
                this.isError = true;
                this.isSuccess = false;
              }
            }
          },
          (error: HttpErrorResponse) => {
            this.isError = true;
            this.msg = "internal server error!";
          }
        );
      }
    }
  
    delcontent(feed, index) {
      if (confirm("Are you sure you want to delete this content")) {
        var obj = {};
        obj["id"] = feed.id;
        this._group.deletefeed(obj).subscribe(
          (data: any) => {
            if (data.error == 0) {
              try {
                this.feedData.splice(index, 1);
              } catch (e) {
                this.msg = "internal server error!";
              }
            }
          },
          (error: HttpErrorResponse) => {
            this.msg = "internal server error!";
          }
        );
      }
    }
  
//ckeditor Image upload
ngAfterViewInit() {
  this.imageuploaders.onAfterAddingFile = (item => {
   item.withCredentials = false;
 });    
  }
 
 openNew(content) {
         
   this.modalReferenceImg =  this.modalService.open(content);       
 }
 
 customImageupload(event,content){
   this.ckeditorevent=event;
    this.openNew(content);
 
 }
 onFileChangedImage(event){
  this.imageuploaders.uploadAll();
  this.progress=1;
 
 }
 
 onSuccessItemImage(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
  
    let data = JSON.parse(response); //success server response
  // console.log(data);
      if(data.error==0){
        this.progress=0;
      //  console.log(this.ckeditorevent.name);
        let fileurl=this.global.objectStorage+'ckeditor/'+data.result.mediaDetail.uploadname;       
        let imagetag="<img src='"+fileurl+"' alt='"+data.result.mediaDetail.title+"'>";
       // console.log(imagetag);       
        CKEDITOR.instances[this.ckeditorevent.name].insertHtml(imagetag);
        this.imageuploaders.clearQueue();
        this.modalReferenceImg.close();
      }else{
 
        this.msgpopup="There is some technical problem. Please try again";
        this.imageuploaders.clearQueue();
      }
     
  }
 
  onErrorItemImage(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
   //console.log('get eroor');   
   let error = JSON.parse(response); //error server response
      this.msgpopup="There is some technical problem. Please try again";
      this.imageuploaders.clearQueue();
  }

}




// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/discussion/groupdetails/groupdetails.component.ts